<div
    type="button"
    class="cerrix-slide-out-backdrop"
    (click)="close()"
    (keydown.Space)="close()"
    tabindex="0"
></div>
<div class="cerrix-slide-out-main">
    <ng-content></ng-content>
</div>
